import { Link } from "react-router-dom";

export default function CityCard({ data, className }) {
  return (
    <Link
      to={`/top-cities/${data.id}`}
      onClick={() => window.scrollTo(0)}
      className={`w-full flex flex-col md:flex-row md:items-center gap-4 md:shadow-cityCard md:p-4 rounded-[8px] md:rounded-[16px] ${className}`}
    >
      <div
        className="bgImage md:!w-[90px] !h-[200px] md:!h-[90px] rounded-lg"
        style={{ backgroundImage: `url(${data.image})` }}
      />
      <div className="text-[12px] sm:text-base font-semibold text-[#858585] sm:text-[#112211]">
        {data.name}
      </div>
    </Link>
  );
}
